export default {
  mobile: false,
  sidebar: true,
  logged: false,
  user: null,
  show_alert: null,
  notifications: [],
  token: null,
  // apiURL: 'http://localhost:8000/api',
  // authURL: 'http://localhost:8000/oauth',
  apiURL: 'https://ezlink.global/ezlink/api',
  authURL: 'https://ezlink.global/ezlink/oauth',
  client_id: 2,
  client_secret: 'teGPuCU0Mdhnv9mGI7oXK5bqKogitpaNQdvXUD6q',
  version: null,
  services: {
    status: [
      {
        id: '0',
        name: 'All'
      },
      {
        id: '1',
        name: 'Confirmed'
      },
      {
        id: '2',
        name: 'Confirmation Problem'
      },
      {
        id: '3',
        name: 'Pending Cancellation'
      },
      {
        id: '4',
        name: 'Cancelled'
      },
      {
        id: '5',
        name: 'InProgress'
      },
      {
        id: '6',
        name: 'Rejected'
      }
    ]
  },
  departaments: [
    {
      id: 0,
      name: 'All'
    },
    {
      id: 1,
      name: 'Operation',
      tips: 'Ex: Confirmations, Cancellations, Changes, Special requests, Notices'
    },
    {
      id: 2,
      name: 'Financeiro',
      tips: 'Invoices only'
    },
    {
      id: 3,
      name: 'Admin'
    },
    {
      id: 4,
      name: 'Client'
    },
    {
      id: 5,
      name: 'Sistemas',
      tips: 'Ex: Divergência de dados ou quando for preciso acionar SUPORTE TÉCNICO'
    },
    {
      id: 6,
      name: 'Product'
    }
  ],
  status: [
    {
      id: '',
      name: 'All'
    },
    {
      id: 1,
      name: 'Open'
    },
    {
      id: 2,
      name: 'On Hold'
    },
    {
      id: 3,
      name: 'Closed'
    },
    {
      id: 4,
      name: 'Under Analysis'
    },
    {
      id: 5,
      name: 'Updated'
    },
    {
      id: 6,
      name: 'Waiting Approval'
    },
    {
      id: 0,
      name: 'In Progress'
    }
  ],
  users: {
    level: [
      {
        id: 0,
        name: 'User (Cangooroo)'
      },
      {
        id: 1,
        name: 'Operator'
      },
      {
        id: 2,
        name: 'Operator Master'
      },

      {
        id: 3,
        name: 'Admin'
      },
      {
        id: 4,
        name: 'Cangooroo'
      },
      {
        id: 5,
        name: 'System'
      }
    ]
  },
  occurrence: {
    type: [
      {
        id: 1,
        name: 'External'
      },
      {
        id: 2,
        name: 'Internal'
      }
    ]
  },
  agency: {
    payment: [
      {
        id: 1,
        name: 'Anticipated'
      },
      {
        id: 2,
        name: 'Billed'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./client/store/config.js